var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":"/campaigns"},on:{"click":_setup.onClickLogo}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/client/assets/images/atelu_logo_white.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }